<template>
  <div class="personality-new-ideas-content" id="plataforma-de-marca-personalidade-inspiradores-de-novas-ideias" data-search-anchor>
    <div class="personality-new-ideas-overlay-title-image">
      <h1 class="personality-new-ideas-image-technology-title">
        {{ PersonalityNewIdeasTitle }}
      </h1>
      <p class="personality-new-ideas-image-technology-text">
        {{ PersonalityNewIdeasTitle2}}
      </p>
    </div>

    <div
      class="personality-new-ideas-banner-image"
      :style="{ backgroundImage: `url(${PersonalityNewIdeasImageSrc})` }"
    ></div>

  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonalityPageMixin from '@/mixins/personality-page-mixin'
import {PersonalityPageStore } from '@/store/brand-plataform-page/personality-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonalityInspiringNewIdeasSection extends Mixins(PersonalityPageMixin) {
  personalityPageStore: PageStoreContract = getModule(PersonalityPageStore, this.$store)

  get PersonalityNewIdeasTitle(): string {
    return this.getElementText(3, 0)
  }

  get PersonalityNewIdeasImageSrc(): string {
    return this.getElementMedia(3, 0)
  }

  get PersonalityNewIdeasTitle2(): string {
    return this.getElementText(3, 1)
  }

  get PersonalityNewIdeasTitle3(): string {
    return this.getElementText(3, 2)
  }

  async getPersonalityPageStore(): Promise<void> {
    await this.personalityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personalityPageStore.isLoading) {
      await this.getPersonalityPageStore()
    }
  }
}
</script>

<style lang="scss">
.personality-new-ideas-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;  
}

.personality-new-ideas-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.personality-new-ideas-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.personality-new-ideas-image-technology-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
  margin-bottom: 2rem;
  margin-top: 4rem;
}

.personality-new-ideas-image-technology-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
